import React, { lazy, Suspense } from 'react';

function iconLazy(loaderFn: () => Promise<{ default: React.ComponentType<any> }>) {
  const LazyComponent = lazy(loaderFn);

  function DynamicComponent(props: any) {
    return (
      <Suspense fallback={<svg {...props} />}>
        <LazyComponent {...props} />
      </Suspense>
    );
  }

  DynamicComponent.displayName = 'DynamicIcon';
  return DynamicComponent;
}

export default iconLazy;
